import { Divider, Typography } from '@mui/material';
import Grid2 from '@mui/material/Unstable_Grid2';
import { concat } from 'lodash';
import React, { FC } from 'react';
import CreateForm from 'src/components/ui-component/form-component/create-form/CreateForm';
import { useApplication } from 'src/context/ApplicationContext';
import { PLATZHALTER_TEXT } from 'src/lib/constants/constant';
import { FormStrucItem } from 'src/lib/types/types';
import PruefAssistenz from 'src/pages/private/online-antrag/antrag-components/PruefAssistenz';
import {
	checkIfPruefAssitenzNeedsToValidate,
	getProjektLaufzeitBISMitProjektlaufzeit_Validation,
	getProjektLaufzeitVON_Validation,
} from 'src/pages/private/online-antrag/application-helper-function/AppHelperfunctions';
import { formStrucProjektdatenPruefassistentGlobal } from 'src/utils/formStruc';
import { checkReadOnlyInUeberarbeitung } from 'src/utils/helper';
import ApplicationHeading from '../../../../application-heading/ApplicationHeading';

// import schemas
import AntragSchema from 'src/lib/paths/antrag_FULL_Paths.json';
const P = AntragSchema.attributes;

const ProjektDatenAntragStipendium: FC<{ hasComment?: boolean }> = ({ hasComment }) => {
	const { application, setApplicationProperty, readOnly } = useApplication();
	const updatedReadOnly = checkReadOnlyInUeberarbeitung(application, readOnly, hasComment);

	return (
		<>
			<ApplicationHeading title='Projektdaten' description={PLATZHALTER_TEXT} />
			<PruefAssistenz
				statusPath={P.Allgemein_Pruefung_Pruefstatus.path}
				hinweisPath={P.Allgemein_Pruefung_Hinweis_Fuer_Den_Antragsteller.path}
				ueberarbeitetAmPath={P.Allgemein_Pruefung_Ueberarbeitet_Am.path}
				erledigtPath={P.Allgemein_Pruefung_Erledigt.path}
				formStruc={formStrucProjektdatenPruefassistentGlobal(application)}
			/>
			<Grid2 spacing={6} container>
				<Grid2 sm={6}>
					<CreateForm
						formStruc={formStruc()}
						formValues={application}
						updateFormValuesFunc={setApplicationProperty}
						readOnly={updatedReadOnly}
					/>
				</Grid2>
				<Grid2 sm={6}>
					<CreateForm
						formStruc={formStrucSpalte2(application)}
						formValues={application}
						updateFormValuesFunc={setApplicationProperty}
						readOnly={updatedReadOnly}
					/>
				</Grid2>
			</Grid2>
			<Divider sx={{ mt: 7, mb: 3, borderBottomWidth: 2, borderColor: 'black' }} />
			<Typography variant='h6' sx={{ mb: 3 }}>
				<b>Ergänzende Hinweise zur Projektbeschreibung (optional):</b>
			</Typography>
			<Typography sx={{ mb: 2 }}>
				Die Förderung bezieht sich auf die von Ihnen im Rahmen der Bewerbungsphase angegebene Projektbeschreibung, d.h. die Förderempfehlung wurde
				für das in der Bewerbung geplante Vorhaben ausgesprochen. Wesentliche inhaltliche Abweichungen sind nicht zulässig.
			</Typography>
			<Typography>
				Falls sich in der Zwischenzeit Änderungen in der Ausgaben- und Finanzierungsplanung oder der Zeitplanung ergeben haben, ist dies i.d.R.
				unproblematisch. Bitte geben Sie diese Angaben und Ergänzungen hier an und erläutern Sie den Grund der Änderungen.
			</Typography>
			<CreateForm formStruc={hinweis()} formValues={application} updateFormValuesFunc={setApplicationProperty} readOnly={updatedReadOnly} />
		</>
	);
};

export default ProjektDatenAntragStipendium;

const formStruc = () => {
	let struc: FormStrucItem[] = [
		{
			fields: [P.Allgemein_Projekttitel, { ...P.Allgemein_Kurzwort, maxCharLength: 12 }],
			userProps: { direction: 'column', columnToDivide: 1 },
		},
	];
	return struc;
};
const formStrucSpalte2 = (application: any) => {
	let struc: FormStrucItem[] = [
		{
			fields: [
				{
					...P.Allgemein_Geplante_Projektlaufzeit_von,
					...getProjektLaufzeitVON_Validation(application),
				},
				{
					...P.Allgemein_Geplante_Projektlaufzeit_bis,
					...getProjektLaufzeitBISMitProjektlaufzeit_Validation(application),
				},
			],
			userProps: { columnToDivide: 2 },
		},
	];
	return struc;
};

const hinweis = () => {
	let struc: FormStrucItem[] = [
		{
			fields: [
				{
					...P.Projektbeschreibung_Startup_Stipendium.schema.attributes.Ergaenzende_Hinweise_Zur_Projektbeschreibung,
					label: '',
					maxCharLength: 2000,
				},
			],
			userProps: { columnToDivide: 1 },
		},
	];
	return struc;
};

export const getFormStrucProjektDatenAntragStipendium = (application: any) => {
	let result: FormStrucItem[] = [];
	result = concat(formStruc(), formStrucSpalte2(application));

	if (checkIfPruefAssitenzNeedsToValidate(application, P.Allgemein_Pruefung_Pruefstatus.path, P.Allgemein_Pruefung_Erledigt.path)) {
		result = concat(formStrucProjektdatenPruefassistentGlobal(application), result);
	}
	return result;
};
